import { isMobileSectionId } from '../../mobile/constants';

export type DashboardConfigTab = {
    id: string;
    label?: string;
    subModules?: string[];
};

export const resolveSubModuleIds = (tab: DashboardConfigTab | undefined, tabs: DashboardConfigTab[]): string[] =>
    (tab?.subModules ?? []).map((name) => tabs.find((t) => t.label === name)?.id).filter((id): id is string => Boolean(id));

// A module belongs on the mobile refresh list if its own id is a mobile section, or any of its subModules resolves to one.
export const refreshesMobileSection = (module: DashboardConfigTab, tabs: DashboardConfigTab[]): boolean =>
    isMobileSectionId(module.id) || resolveSubModuleIds(module, tabs).some(isMobileSectionId);
